<template>
  <div class="basic-info-container">

    <div class="info-form">
      <!-- 头像上传区域：点击头像预览，点击相机选择并上传 -->
      <div class="avatar-upload">
        <input
          ref="avatarFileInput"
          type="file"
          accept="image/*"
          class="avatar-file-input"
          @change="onAvatarFileSelected"
        />
        <img
          :src="displayAvatar"
          alt="头像"
          class="avatar-image"
          @click="avatarPreviewVisible = true"
        />
        <el-dialog
          v-model="avatarPreviewVisible"
          width="320px"
          align-center
          append-to-body
          destroy-on-close
          class="avatar-preview-dialog"
        >
          <img :src="displayAvatar" alt="" class="avatar-preview-popup-img" />
        </el-dialog>
        <button
          type="button"
          class="upload-icon"
          :class="{ disabled: isUploadingAvatar }"
          :disabled="isUploadingAvatar"
          aria-label="选择新头像"
          @click.stop="triggerAvatarFileSelect"
        >
          <AppIcon
            v-if="!isUploadingAvatar"
            name="camera"
            size="sm"
            aria-label=""
          />
          <AppIcon
            v-else
            name="refresh"
            size="sm"
            class="app-icon--spin"
            aria-label="上传中"
          />
        </button>

        <el-dialog
          v-model="avatarCropVisible"
          width="400px"
          append-to-body
          destroy-on-close
          class="avatar-crop-dialog"
          :close-on-click-modal="false"
          @opened="onAvatarCropDialogOpened"
          @closed="onAvatarCropDialogClosed"
        >
          <div class="avatar-crop-stage">
            <img
              v-show="avatarCropObjectUrl"
              ref="cropperImageRef"
              :src="avatarCropObjectUrl"
              alt=""
              class="avatar-crop-source"
            />
          </div>
          <template #footer>
            <div class="avatar-crop-footer">
              <el-button @click="cancelAvatarCrop">取消</el-button>
              <el-button
                type="primary"
                :loading="isUploadingAvatar"
                :disabled="!avatarCropObjectUrl"
                @click="confirmAvatarCrop"
              >
                上传
              </el-button>
            </div>
          </template>
        </el-dialog>
      </div>

      <!-- 资料输入表单 -->
      <div class="form-fields">
        <div class="form-row">
          <label>账号:</label>
          <span class="readonly-value">{{ formData.no || '—' }}</span>
        </div>

        <div class="form-row">
          <label for="nickname">昵称:</label>
          <input
            type="text"
            id="nickname"
            v-model="formData.name"
            class="input-field"
          />
        </div>

        <div class="form-row">
          <label>电话:</label>
          <span class="readonly-value">{{ formData.phone || formData.mobile || '—' }}</span>
        </div>

        <div class="form-row full-width">
          <label for="introduction">个性签名:</label>
          <textarea
            id="introduction"
            v-model="formData.sign"
            placeholder="介绍介绍自己吧..."
            class="textarea-field"
          ></textarea>
        </div>
      </div>
    </div>

    <!-- 保存按钮 -->
    <div class="save-info-container">
      <button
        class="save-button"
        :class="{ success: isSaveSuccess }"
        @click="saveInfo"
      >
        <span v-if="isSaving"> <span class="loader"></span> 保存中... </span>
        <span v-else-if="isSaveSuccess" class="success-message">
          <AppIcon name="check" size="sm" class="success-icon" aria-label="" />
          <span class="success-text">保存成功</span>
        </span>
        <span v-else>保存个人信息</span>
      </button>
    </div>
  </div>
  <!-- 提示框 -->
  <MessagePopup v-if="showPopup" :message="popupMessage" :type="popupType" />
</template>

<script setup>
import MessagePopup from '@/features/message/components/MessagePopup.vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import { useUserBaseInfo } from '@/features/user/composables/useUserBaseInfo'

const {
  formData,
  displayAvatar,
  popupMessage,
  popupType,
  showPopup,
  isSaving,
  isSaveSuccess,
  isUploadingAvatar,
  avatarPreviewVisible,
  avatarCropVisible,
  avatarCropObjectUrl,
  avatarFileInput,
  cropperImageRef,
  saveInfo,
  triggerAvatarFileSelect,
  onAvatarFileSelected,
  onAvatarCropDialogOpened,
  onAvatarCropDialogClosed,
  cancelAvatarCrop,
  confirmAvatarCrop,
} = useUserBaseInfo()
</script>

<style scoped src="@/features/user/styles/operationArea/UserBaseInfo.css"></style>
<style scoped src="@/features/user/styles/operationArea/OperationAreaTheme.css"></style>
<!-- 裁剪弹窗 teleport 到 body，scoped 选不中 .el-dialog，需单独全局样式 -->
<style>
.el-dialog.avatar-crop-dialog {
  width: 400px !important;
  max-width: 92vw;
  box-sizing: border-box;
  --el-color-primary: var(--color-user-center-primary);
}

.el-dialog.avatar-crop-dialog .el-dialog__body {
  padding: 12px 12px 8px;
  box-sizing: border-box;
}

.el-dialog.avatar-crop-dialog .el-dialog__footer {
  padding: 8px 12px calc(12px + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .el-dialog.avatar-crop-dialog {
    width: min(480px, 92vw) !important;
  }
}
</style>
